import Card from '@mui/material/Card'
import CardActions from '@mui/material/CardActions'
import CardContent from '@mui/material/CardContent'
import Box from '@mui/material/Box'
import { Skeleton, Stack } from '@mui/material'

const VendorContactCardsSkeleton = () => {
  return (
    <Card sx={{ maxWidth: 420, width: '100%' }}>
      <CardContent sx={{ backgroundColor: 'grey.200' }}>
        <Box sx={{ height: 104 }}>
          <Stack spacing={1}>
            <Skeleton variant="rectangular" height={104} />
          </Stack>
        </Box>
      </CardContent>
      <CardActions sx={{ px: 2 }}>
        <Box sx={{ height: 42 }}>
          <Skeleton variant="text" height={40} width={300} />
        </Box>
      </CardActions>
    </Card>
  )
}

export default VendorContactCardsSkeleton
